import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, Navigate } from 'react-router-dom';
import { Heart, Search, Bell } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const DashboardLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const tabs = [
    { path: '/dashboard/saved', label: 'Saved Properties', icon: Heart },
    { path: '/dashboard/searches', label: 'Saved Searches', icon: Search },
    { path: '/dashboard/alerts', label: 'Alert Subscriptions', icon: Bell },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen py-8" data-testid="dashboard-layout">
      <div className="container mx-auto px-6 md:px-12">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-8 font-heading">
          My Dashboard
        </h1>

        <div className="border-b border-slate-200 mb-8">
          <nav className="flex gap-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className={`flex items-center gap-2 pb-4 border-b-2 transition-colors ${
                    isActive(tab.path)
                      ? 'border-[#F5A623] text-[#F5A623]'
                      : 'border-transparent text-slate-600 hover:text-slate-900'
                  }`}
                  data-testid={`tab-${tab.path}`}
                >
                  <Icon className="h-5 w-5" />
                  <span className="font-medium">{tab.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
